import React from 'react';
import { Box, Fab, Tooltip } from '@mui/material';
import { Map as MapsIcon } from '@mui/icons-material';
import { useGame } from '../context/GameContext';

const FloatingMapActions = () => {
  const { openCurrentMapEditor } = useGame();
  return (
    <Box
      sx={{
        position: 'fixed',
        top: '200px',
        right: '18px',
        display: 'flex',
        opacity: 0.6,
        flexDirection: 'column',
        gap: '4px',
        zIndex: 1000,
        padding: '8px',
      }}
    >
      {/* Map Button */}
      <Tooltip title="Edit Map" placement="left">
        <Fab size="small" color="primary" onClick={openCurrentMapEditor}>
          <MapsIcon />
        </Fab>
      </Tooltip>
    </Box>
  );
};

export default FloatingMapActions;

